import { userSchema } from './user.schema';
import { fleetVehicleInformationSchema } from '../../fleet/schemas/fleet-device-settings.schema';
import { z } from 'zod/v4';

export const fleetUserSchema = userSchema
  .extend({
    externalName: z.string().nullable(),
    formattedDataVersion: z.string().nullable(),
  })
  .merge(
    fleetVehicleInformationSchema.omit({
      lastCommunicationRequest: true,
      lastConnected: true,
      deviceId: true,
    })
  );

export type FleetUser = z.infer<typeof fleetUserSchema>;
